import { render, staticRenderFns } from "./advancedShippingNote.vue?vue&type=template&id=402f8e66&scoped=true&"
import script from "./advancedShippingNote.vue?vue&type=script&lang=js&"
export * from "./advancedShippingNote.vue?vue&type=script&lang=js&"
import style0 from "./advancedShippingNote.vue?vue&type=style&index=0&id=402f8e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f8e66",
  null
  
)

export default component.exports